import { MarkerType } from 'reactflow';
import type { Edge } from 'reactflow';
import type { CustomEdge } from '@src/components/custom-nodes/types';


export const createTransparentEdge = (from: string, to: string, props: Partial<Edge> = {}) => {
  return {
    id: `edge:${from}=>${to}`,
    source: from,
    target: to,
    // use standard edge type so it renders, but make it invisible via style
    type: 'smoothstep',
    markerEnd: undefined,
    style: { ...(props as Edge).style, stroke: 'transparent', strokeOpacity: 0, opacity: 0, pointerEvents: 'none' },
    labelStyle: { opacity: 0, ...(props as Edge).labelStyle },
    ...props,
  } as CustomEdge;
}

export const createDirectedEdge = (from: string, to: string, props: Partial<Edge> = {}) => {
  return {
    id: `edge:${from}=>${to}`,
    source: from,
    target: to,
    markerEnd: { type: MarkerType.Arrow },
    type: 'smoothstep',
    ...props,
  } as CustomEdge;
}

export const createUndirectedEdge = (from: string, to: string, props: Partial<Edge> = {}) => {
  return {
    id: `edge:${from}<=>${to}`,
    source: from,
    target: to,
    type: 'smoothstep',
    ...props,
  } as CustomEdge;
};
